import { render } from "./LinkCardView.vue?vue&type=template&id=77124f00"
import script from "./LinkCardView.vue?vue&type=script&lang=js"
export * from "./LinkCardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__